export enum KeywordType {
  AuditInfoAndFeesMain = 1,
  AuditInfoAndFeesComment = 2,
  AuditReportAuditor = 3,
  AuditReportAccountingStandard = 4,
  AuditReportEmphasisOfMatters = 5,
  AuditReportKeyAuditMatters = 6,
  BoardMeetings = 7,
  BoardAttendance = 8,
  ExecutiveManagement = 9,
  CommitteeMeetings = 10,
  OwnershipBoardShares = 11,
  OwnershipLargestShareholder = 12,
  OwnershipTotalShares = 13,
  SalaryOneExecutiveCompensationOne = 14,
  SalaryOneExecutiveCompensationTwo = 15,
  SalaryOneDirectorsCompensationOne = 16,
  SalaryOneDirectorsCompensationTwo = 17,
  SalaryTwoOwnershipGuidelinesOne = 18,
  SalaryTwoOwnershipGuidelinesTwo = 19,
  SalaryTwoCompensationConsultantOne = 20,
  SalaryTwoCompensationConsultantTwo = 21,
  SalaryTwoNonExecutiveFeesOne = 22,
  SalaryTwoNonExecutiveFeesTwo = 23,
  AccountingSales = 24,
  AccountingGross = 25,
  AccountingEbit = 26,
  AccountingInterestExpense = 27,
  AccountingEbt = 28,
  AccountingIncomeTaxes = 29,
  AccountingNetIncome = 30,
  AccountingEps = 31,
  AccountingNetCash = 32,
  AccountingTotalCurrentAssets = 33,
  AccountingTotalAssets = 34,
  AccountingLongTermDebt = 35,
  AccountingShortTermDebt = 36,
  AccountingTotalCurrentLiabilities = 37,
  AccountingTotalShareholderEquity = 38,
  SocietyAssurance = 39,
  SocietyDonation = 40,
  SocietyCorruption = 41,
  SocietyDiscrimination = 42,
  SocietyHumanRight = 43,
  SocietySuppliers = 44,
  EmployeesHires = 45,
  EmployeesHealth = 46,
  EmployeesAverageAge = 47,
  EmployeesLeadership = 48,
  EmployeesDisabled = 49,
  EmployeesGenderGap = 50,
  EmployeesParentalLeave = 51,
  EmployeesTraining = 52,
  EmployeesTradeUnion = 53,
  EmployeesCollective = 54,
  Energy = 55,
  Water = 56,
  Emission = 57,
  Waste = 58,
  EnvironmentalCompliance = 59,
  VotingResults = 60
}
